export enum TenancyAgreementSignatureTypes {
    ESIGN = 1,
    MANUALLY_SIGN = 2,
    ALREADY_AGREED = 3
}
export const ReverseTenancyAgreementSignatureTypes = {
    [TenancyAgreementSignatureTypes.ESIGN]: 'COHO eSignature',
    [TenancyAgreementSignatureTypes.MANUALLY_SIGN]: 'Wet Signature',
    [TenancyAgreementSignatureTypes.ALREADY_AGREED]: 'Already Signed',
}
